<template>
  <div class="flex items-start flex-wrap gap-y-3 col-span-7">
    <template v-for="(value, key) in validNewChanges">
      <EventChange
        v-if="!isTheSame(value, validOldChanges[key])"
        :key="key"
        class="mr-3"

        :label="key"
        :value="value"
        :old="validOldChanges[key]"
      />
    </template>
  </div>
</template>

<script>

import EventChange from "./EventChange"
import { isEqual } from "lodash"

const unvalidFields = ['uid', 'id', 'external_id', 'sku']

export default {
  components: {
    EventChange,
  },
  props: {
    newValues: Object,
    oldValues: Object,
  },
  created() {
    // console.log(this.validOldChanges, this.validNewChanges)
  },
  methods: {
    isTheSame(val, old) {
      val = val || null
      old = old || null

      if (Array.isArray(val) && Array.isArray(old) && !val.length && !old.length) return true

      if (!val && Array.isArray(old) && !old.length) return true
      if (Array.isArray(val) && !val.length && !old) return true

      return isEqual(val, old)
    },
    getValidChanges(obj) {
      if (!obj) return;
      let data = JSON.parse(JSON.stringify({...obj}))

      unvalidFields.forEach(field => {
        if (data[field]) delete data[field]
      })

      Object.keys(data).forEach(field => {
        const isObject = typeof data[field] === 'object' && data[field] !== null

        if (isObject) {
          unvalidFields.forEach(subField => {
            if (data[field][subField]) delete data[field][subField]
          })
        }
        if (isObject && Object.keys(data[field]).length === 0) {
          data[field] = null
        }
        if (!data[field]) {
          data[field] = null
        }
      })

      return data
    },
  },
  computed: {
    validNewChanges() {
      return this.getValidChanges(this.newValues) || {}
    },
    validOldChanges() {
      return this.getValidChanges(this.oldValues) || {}
    },
  },
}

</script>
